export const createStatusAvatarList = (trackerDS, statuses, setter) => {
        let statusIDCntMap = new Map();
        let statusCntList = [];

        Object.entries(trackerDS)
        .map(([uniqueKey, dp]) => {
            const dpStatusId = dp.status?.status_id || dp.status?.id || null;
            if (dpStatusId) {
                statusIDCntMap.set(dpStatusId, (statusIDCntMap.has(dpStatusId) ? statusIDCntMap.get(dpStatusId) : 0) + 1)
            }
        })

        // sort map in desc order of status count for the player
        const sortedMap = new Map([...statusIDCntMap.entries()].sort((a, b) => b[1] - a[1]));
        
        if (sortedMap && sortedMap.size > 0) {
            for (const [statusId, statusCnt] of sortedMap) {
                if (statusCnt > 0) {
                    const status = statuses.filter(s => {
                        if (s.id === statusId || s.status_id === statusId) return s;
                    });
    
                    if (status && status.length > 0) {
                        statusCntList.push([status[0], statusCnt])
                    }
                }
            }

            if (statusCntList && statusCntList.length > 0) {
                setter(statusCntList);
            }
        }
    }